export enum KitPattern {
  SOLID = 'solid',
  STRIPES_VERTICAL = 'stripes_vertical',
  STRIPES_HORIZONTAL = 'stripes_horizontal',
  HALVES = 'halves',
  QUARTERS = 'quarters',
  SASH = 'sash',
  CHECKERED = 'checkered',
  GRADIENT = 'gradient',
  PINSTRIPES = 'pinstripes',
}

/** Human-readable labels for the pattern picker. */
export const KIT_PATTERN_LABELS: Record<KitPattern, string> = {
  [KitPattern.SOLID]: 'Однотонный',
  [KitPattern.STRIPES_VERTICAL]: 'Вертикальные полосы',
  [KitPattern.STRIPES_HORIZONTAL]: 'Горизонтальные полосы',
  [KitPattern.HALVES]: 'Половины',
  [KitPattern.QUARTERS]: 'Четверти',
  [KitPattern.SASH]: 'Диагональная полоса',
  [KitPattern.CHECKERED]: 'Клетка',
  [KitPattern.GRADIENT]: 'Градиент',
  [KitPattern.PINSTRIPES]: 'Тонкие полосы',
};

/** How many colors are required for each pattern. */
export const KIT_PATTERN_COLOR_COUNT: Record<KitPattern, number> = {
  [KitPattern.SOLID]: 1,
  [KitPattern.STRIPES_VERTICAL]: 2,
  [KitPattern.STRIPES_HORIZONTAL]: 2,
  [KitPattern.HALVES]: 2,
  [KitPattern.QUARTERS]: 2,
  [KitPattern.SASH]: 2,
  [KitPattern.CHECKERED]: 2,
  [KitPattern.GRADIENT]: 2,
  [KitPattern.PINSTRIPES]: 2,
};
